import {
	AnalyticsEnvironmentConfig,
	B2CPolicies,
	EnvironmentName,
	EnvironmentRef,
	Scopes
} from '../../environments/interfaces/environment.interface';
import { environment } from '../../environments/environment';
import { InjectionToken } from '@angular/core';
import { Endpoints } from '../../environments/interfaces/endpoints/endpoints.interface';

export class Environment implements EnvironmentRef
{
	get production(): boolean
	{
		return this.envRef.production;
	}
	get baseUrl(): string
	{
		return this.envRef.baseUrl;
	}
	get env(): EnvironmentName
	{
		return this.envRef.env;
	}
	get azureMapsApiKey(): string 
	{
		return this.envRef.azureMapsApiKey;
	}
	get endpoints(): Endpoints
	{
		return this.envRef.endpoints;
	}
	get b2cPolicies(): B2CPolicies
	{
		return this.envRef.b2cPolicies;
	}
	get clientId(): string
	{
		return this.envRef.clientId;
	}
	get scope(): Scopes
	{
		return this.envRef.scope;
	}
	get aemBaseUrl(): string
	{
		return this.envRef.aemBaseUrl;
	}
	get appWalkmeUrl(): string
	{
		return this.envRef.appWalkmeUrl;
	}
	get buyPartsUrl(): string
	{
		return this.envRef.buyPartsUrl;
	}
	get requestServiceUrl(): string
	{
		return this.envRef.requestServiceUrl;
	}
	get manageFinancingUrl(): string
	{
		return this.envRef.manageFinancingUrl;
	}

	get analytics(): AnalyticsEnvironmentConfig
	{
		return this.envRef.analytics;
	}

	get openContactFormUrl(): string
	{
		return this.envRef.openContactFormUrl;
	}

	get requestServiceEquipmentDetails(): string
	{
		return this.envRef.requestServiceEquipmentDetails;
	}

	get warrantyPromoBannerUrl(): string
	{
		return this.envRef.warrantyPromoBannerUrl;
	}

	get buyPartsPromoBannerUrl(): string
	{
		return this.envRef.buyPartsPromoBannerUrl;
	}
	get shopDeliveryAddressUrl(): string
	{
		return this.envRef.shopDeliveryAddressUrl;
	}
	get zendeskChatbotUrl(): string
	{
		return this.envRef.zendeskChatbotUrl;
	}

	get myInsightsPortalUrl(): string
	{
		return this.envRef.myInsightsPortalUrl;
	}

	get ecomBaseUrl(): string
	{
		return this.envRef.ecomBaseUrl;
	}

	constructor(readonly envRef: EnvironmentRef) {}
}

export const expEnvironmentRef = new InjectionToken<Environment>(
	'EnvironmentRef',
	{
		providedIn: 'root',
		factory: () => new Environment(environment)
	}
);
